import { getSessionManagementServiceInstance } from '../../sessionManagement/SessionManagementService';

/*
 * Determines which schedule-related actions a user has permission to perform. 
 */
export namespace SchedulePermissionsService {
  // This covers edit, rename, delete, enable/disable
  export function canEditSchedule() {
    return getSessionManagementServiceInstance().isSessionServerAdmin();
  }

  export function canRunSchedule() {
    return getSessionManagementServiceInstance().isSessionSiteOrServerAdmin();
  }
}
